import { useState } from 'react';
import { Copy, Check, MessageCircle, Landmark } from 'lucide-react';
import { toast } from 'sonner';
import { site } from '../data/site';

export const BankPayment = () => {
  const [copied, setCopied] = useState(false);

  const copyAccount = async () => {
    try {
      await navigator.clipboard.writeText(site.bank.accountNumber);
      setCopied(true);
      toast.success('Account number copied — send your receipt on WhatsApp after payment.');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Copy failed — please write down the account number instead.');
    }
  };

  return (
    <div
      data-testid="bank-payment-panel"
      className="grain relative overflow-hidden rounded-2xl bg-pine p-8 text-white sm:p-10"
    >
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-emerald-600/40 blur-[100px]"
        aria-hidden="true"
      />
      <div className="relative">
        <div className="flex items-center gap-4">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-goldlight/15 text-goldlight">
            <Landmark size={22} strokeWidth={1.8} />
          </span>
          <div>
            <h3 className="font-display text-2xl font-bold">Pay by Bank Transfer</h3>
            <p className="mt-1 text-sm text-white">
              For any service or course payment — then send your receipt on WhatsApp for
              confirmation.
            </p>
          </div>
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-3">
          <div className="rounded-xl border-2 border-white bg-white px-5 py-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink">Bank</p>
            <p className="mt-1.5 font-display text-lg font-bold text-forest" data-testid="bank-name">
              {site.bank.bankName}
            </p>
          </div>
          <div className="rounded-xl border-2 border-white bg-white px-5 py-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink">
              Account Number
            </p>
            <div className="mt-1.5 flex items-center gap-2">
              <p className="font-display text-lg font-bold tracking-wider text-forest" data-testid="bank-account-number">
                {site.bank.accountNumber}
              </p>
              <button
                onClick={copyAccount}
                data-testid="bank-copy-button"
                aria-label="Copy account number"
                className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-ink/20 text-ink transition-colors hover:border-forest hover:text-forest"
              >
                {copied ? <Check size={14} className="text-forest" /> : <Copy size={14} />}
              </button>
            </div>
          </div>
          <div className="rounded-xl border-2 border-white bg-white px-5 py-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink">
              Account Name
            </p>
            <p className="mt-1.5 font-display text-lg font-bold text-forest" data-testid="bank-account-name">
              {site.bank.accountName}
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href={site.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="bank-whatsapp-receipt"
            className="btn-mint"
          >
            <MessageCircle size={17} /> Send Receipt on WhatsApp
          </a>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white">
            We confirm every payment personally
          </p>
        </div>
      </div>
    </div>
  );
};
